import React from 'react';
import { buildLabelId } from "../../form/utils";
import { getUniqueId } from "../../utils";
import { DateTimeSegments } from "../date-time-segments";
import { defaultTimeAriaLabels } from "./constants";
import { TimeSegmentRow } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var TimePicker = function TimePicker(_ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? defaultTimeAriaLabels : _ref$ariaLabels,
      handleChange = _ref.handleChange,
      _ref$selectedTime = _ref.selectedTime,
      selectedTime = _ref$selectedTime === void 0 ? {} : _ref$selectedTime,
      showMilliseconds = _ref.showMilliseconds,
      showSeconds = _ref.showSeconds;
  return ___EmotionJSX(TimeSegmentRow, null, ___EmotionJSX(DateTimeSegments, {
    ariaLabels: ariaLabels,
    labelId: buildLabelId("StencilTimePicker-".concat(getUniqueId())),
    onChange: handleChange,
    segmentValues: selectedTime,
    showDate: false,
    showMilliseconds: showMilliseconds,
    showSeconds: showSeconds,
    showSpinButtons: true,
    showTime: true
  }));
};

export default TimePicker;